import React from 'react';
import {useHaptic} from "../../Hooks/useHaptic";
import styled, { keyframes, css } from "styled-components";

const colorWaveEasy = keyframes`
  0% {
    color: #fff;
    fill: #fff;
  }
  50% {
    color: #8A2BE2;
    fill: #8A2BE2;
  }
  100% {
    color: #fff;
    fill: #fff;
  }
`;

const colorWavePro = keyframes`
  0% {
    color: #fff;
    fill: #fff;
  }
  50% {
    color: #FF8C00;
    fill: #FF8C00;
  }
  100% {
    color: #fff;
    fill: #fff;
  }
`;

const AnimatedContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
    //
    //&.active {
    //    svg, h1 {
    //        animation: colorWave 1s ease-in-out;
    //    }
    //
    //    svg path {
    //        animation: colorWave 1s ease-in-out;
    //    }
    //}

    &.active[data-type="easy"] {
        //svg, h1 {
        //    color: #8A2BE2;
        //    fill: #8A2BE2;
        //}
        //
        //svg path {
        //    color: #8A2BE2;
        //    fill: #8A2BE2;
        //}
    }

    &.active[data-type="pro"] {
        svg, h1 {
            color: #FF8C00;
            fill: #FF8C00;
        }
        
        
        
        svg path {
            color: #FF8C00;
            fill: #FF8C00;
        }
    }
`;

const Selector = (
    {
        mode,
        activeMode,
        setActiveMode,
    }
) => {
    const {hapticFeedBack} = useHaptic("select")
    const isActive = activeMode === mode.name;
    return (
        <div style={{
            padding: "16px 12px",
            borderRadius: 8,
            display: "flex",
            gap: 12,
            alignItems: "center",
            justifyContent: "space-between",
            border: isActive ? mode.name === "easy" ? "1px solid #fff" : "1px solid #FF8C00" : "1px solid #38393A",
            backgroundColor: "#232425",
            cursor: "pointer",
            width: "100%",
            transition: "all 0.2s ease-in-out",
        }}
             onClick={() => {
                 setActiveMode(mode.name)
                 hapticFeedBack()
             }}
        >
            <AnimatedContainer 
                className={isActive ? 'active' : ''} 
                data-type={mode.name}
            >
                {mode.icon}
                <h1 style={{
                    fontSize: "16px",
                    fontWeight: "700",
                }}>{mode.title} <span style={{opacity: 0.7, color: "white"}}>mode</span></h1>
            </AnimatedContainer>
            <img src="/images/plans_icons/info.svg" alt="info"/>
        </div>
    )
}

export const ModeSelector = (
    {
        activeMode,
        setActiveMode,
        modes,
    }
) => {
    return (
        <div style={{display: "flex", gap: 8, justifyContent: "space-between"}}>
            {modes.map(mode => <Selector
                key={mode.name}
                mode={mode}
                activeMode={activeMode}
                setActiveMode={setActiveMode}
            />)}
        </div>
    )
}